import { Component, OnInit, inject, output } from '@angular/core';
import { ProductCategoryService } from 'src/app/services/product-category.service';
import { ProductCategory } from 'src/app/common/ProductCategory';
import { ProductFilter } from 'src/app/common/ProductFilter';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';
import { isDefaultFilter } from 'src/app/common/filter-state';
import { FilterCardComponent } from '../filter-card/filter-card.component';

@Component({
    imports: [FormsModule, KENDO_DROPDOWNS, FilterCardComponent],
    selector: 'app-product-search',
    templateUrl: './product-search.component.html'
})
export class ProductSearchComponent implements OnInit {
  private productCategoryService = inject(ProductCategoryService);

  productCategories: ProductCategory[];
  searchWord: string = '';
  public isActive: boolean = true;
  public isInactive: boolean = false;
  productCategoryId?: string = null;
  // #178: see search-bar — the dropdown renders `name` now.
  defaultItem: ProductCategory = {
    id: null,
    shortName: $localize`Alle`,
    description: $localize`Alle Kategorien`,
    name: $localize`Alle`,
  };

  readonly searchCriteria = output<ProductFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private readonly defaults = {
    searchWord: '',
    productCategoryId: null as string,
    isActive: true,
    isInactive: false,
  };

  public get isFiltered(): boolean {
    return !isDefaultFilter(
      {
        searchWord: this.searchWord,
        productCategoryId: this.productCategoryId,
        isActive: this.isActive,
        isInactive: this.isInactive,
      },
      this.defaults
    );
  }

  public resetFilter(): void {
    this.searchWord = this.defaults.searchWord;
    this.productCategoryId = this.defaults.productCategoryId;
    this.isActive = this.defaults.isActive;
    this.isInactive = this.defaults.isInactive;
    this.searchThis();
  }

  searchThis() {
    this.searchCriteria.emit(
      new ProductFilter(
        this.isActive,
        this.isInactive,
        this.searchWord,
        this.productCategoryId
      )
    );
  }

  public productCategoryChange(value: ProductCategory): void {
    this.searchCriteria.emit(
      new ProductFilter(
        this.isActive,
        this.isInactive,
        this.searchWord,
        value.id
      )
    );
  }

  ngOnInit(): void {
    this.productCategoryService
      .get()
      .subscribe((res: ProductCategory[]) => {
        this.productCategories = res;
      });
  }

  toggleIsActive(_event: Event) {
    this.searchCriteria.emit(
      new ProductFilter(
        this.isActive,
        this.isInactive,
        this.searchWord,
        this.productCategoryId
      )
    );
  }
}
